import { configureClassValidatorI18n } from '@resource/class-validator-i18n';

import store from './configureStore';

configureClassValidatorI18n(store);
